module.exports = "<div class=\"panel panel-default app\">\n    <div class=\"panel-heading text-center p-0 pt-5\">\n        <a href=\"http://www.cooperforte.coop.br/\" title=\"Cooperforte\">\n            <img class=\"pt-10\" src=\"{{$ctrl.logo}}\" title=\"Cooperforte\"/>\n        </a>\n        <div class=\"linhaBottom\">\n            <h5 class=\"pt-5 text-uppercase\"><strong>{{$ctrl.systemTitle}}</strong></strong></h5>\n        </div>\n    </div>\n    <ui-view></ui-view>\n    <div class=\"text-center\">versão 1.2.25</div>\n</div>\n\n\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.template.html
// module id = 817
// module chunks = 0